import { render, staticRenderFns } from "./StartupInformationsForm.vue?vue&type=template&id=6dbcff0a&"
import script from "./StartupInformationsForm.vue?vue&type=script&lang=js&"
export * from "./StartupInformationsForm.vue?vue&type=script&lang=js&"
import style0 from "./StartupInformationsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports